import React, { useEffect, useState } from 'react';
import Stylesheet from './About.module.css';
import EnigmaBrand from '../../../assets/brand-box.svg';
import {firestore} from '@enigma/core/services';
import Loading from '../../../components/Spinner/Standard/Standard';
import Button from '../../../elements/Button/Button';

const About = (props) => {
    const [license, setLisence] = useState(null);
    document.title = `Help - Software License`;
    useEffect(() => {
        firestore.doc('about/license').get()
        .then(snap => setLisence(snap.data()))
    }, [props])

    if (license === null) return (
        <div className={Stylesheet.Container}>
            <div className={Stylesheet.Loading}>
                <Loading show />
            </div>
        </div>
    )
    return (
        <div className={Stylesheet.Container}>
            <div className={Stylesheet.Brand}>
                <img src={EnigmaBrand} alt="enigma softworks brand" />
            </div>
            <div className={Stylesheet.Metadata}>
                <h1>fleet managment console</h1>
                <h3>software licence</h3>
                <p>{license.summary}</p>
                <div className={Stylesheet.Manual}>
                    <a href={license.manual_url} target="_blank" rel="noopener noreferrer">
                        <Button link secondary>view user manual</Button>
                    </a>
                </div>
                <h4>Current version of application: {license.app_version}<br />
                Current build version: {license.build_version} Stable Build (LTS) (Long-Term-Support)</h4>
                <h5 className={Stylesheet.Copyright}>
                &copy;enigmasoftworks 2021.
                &nbsp;<span>all</span> rights reserved.</h5>
            </div>
        </div>
    )
}

export default About;